import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { ToadMessage } from 'utils/types';
import { useAdminParams } from 'utils/helpers';

import { CONTENTS, CONVERSATIONS } from '../utils/constants';

export default function useGetConversationMessages(
  conversationId?: string,
  // callback?: () => void,
) {
  // const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();

  const args = state;

  return useQuery<ToadMessage[]>({
    queryKey: [CONVERSATIONS, conversationId, CONTENTS],
    queryFn: async () => {
      const api = new Api(args);

      const { data } = await api.get(
        await withAcl({
          account: {
            url: `api/v1/channels/toad/conversations/${conversationId}/contents`,
            params: { perPage: 100 },
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/toad/conversations/${conversationId}/contents`,
            params: { perPage: 100 },
          },
        }),
      );

      return data.reverse();
    },
    enabled: !!conversationId,
  });
}
